import { useState, useEffect, useMemo } from "react";
import {
  useGetAllTransactions,
  useGetManagementTransactions,
} from "../../../hooks/queries/useTransactionQueries";

export const useTransactionData = ({
  apiFilters,
  managementApiFilters,
  isSuperAdmin,
}) => {
  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const [previousTransactions, setPreviousTransactions] = useState([]);
  const regularQuery = useGetAllTransactions(apiFilters, {
    enabled: !isSuperAdmin,
  });
  const managementQuery = useGetManagementTransactions(managementApiFilters, {
    enabled: isSuperAdmin,
  });
  const {
    data: transactionResponse = {},
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  } = isSuperAdmin ? managementQuery : regularQuery;

  useEffect(() => {
    if (!isLoading && !initialLoadDone) {
      setInitialLoadDone(true);
    }
  }, [isLoading, initialLoadDone]);

  const currentTransactions = useMemo(
    () => transactionResponse.content || [],
    [transactionResponse.content],
  );

  useEffect(() => {
    if (currentTransactions.length > 0) {
      setPreviousTransactions(currentTransactions);
    }
  }, [currentTransactions]);

  const transactions = useMemo(() => {
    if (isFetching && previousTransactions.length > 0) {
      return previousTransactions;
    }
    return currentTransactions;
  }, [isFetching, previousTransactions, currentTransactions]);
  const totalElements = useMemo(
    () => transactionResponse.totalElements || 0,
    [transactionResponse.totalElements],
  );

  const totalPages = useMemo(
    () => transactionResponse.totalPages || 0,
    [transactionResponse.totalPages],
  );

  return {
    transactions,
    totalElements,
    totalPages,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    initialLoadDone,
    noTransactions: transactions.length === 0,
  };
};

export default useTransactionData;
